export const INVALID_NAVLINK = 'invalid navlink was sent'
export const getNotSupportedRouteMessage = (routeName: string) =>
  `route corresponding to the navlink which has ${routeName} in it is non existent`
export const NOT_LOGGED_IN = 'You are logged out, login again'
